/**
 * Build metadata: set at compile time in vite.config.mjs (`define`), refreshed on every `vite build`.
 */
export function getBuildMeta() {
  const number = String(import.meta.env.VITE_BUILD_NUMBER || '—');
  const timeIso = import.meta.env.VITE_BUILD_TIME;
  let timeLabel = '—';
  if (timeIso) {
    try {
      timeLabel = new Date(String(timeIso)).toLocaleString(undefined, {
        dateStyle: 'medium',
        timeStyle: 'short'
      });
    } catch {
      timeLabel = String(timeIso);
    }
  }
  return { number, timeIso: timeIso || null, timeLabel };
}
